import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useCallback } from 'react';
import { LuImagePlus } from 'react-icons/lu';
import { useSelector } from 'react-redux';
import { useDropzone } from 'react-dropzone';
import './style.css';

const NotesUploader = ({
  id,
  onChange,
  src = '',
  value = '',
  label,
  name,
  description,
  maxSize = '',
  containerStyle = 'w-24 h-24',
  setAllUploadsCompleted,
  setUploadError,
  configMapping,
  handleFileAddition,
  documentOrData = true,
  uploaderLength,
  uploaderHeight,
  uploaderMargin,
  ...rest
}) => {
  const fileTypesAndExtensions = {
    'application/pdf': '.pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      '.docx',
    'application/msword': '.doc',
    'application/vnd.ms-powerpoint': '.ppt',
    'application/vnd.ms-excel.sheet.macroEnabled.12': '.xlsm',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      '.xlsx',
    'application/vnd.ms-excel': '.xls',
    'text/plain': '.txt',
    'video/mp4': '.mp4',
    'audio/mp4': '.m4a',
    'audio/mpeg': '.mp3',
  };

  const buttonStyle = {
    display: 'block',
    margin: '10px auto',
    padding: '10px 20px',
    backgroundColor: 'rgb(120 120 120)',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    width: '110px',
    textAlign: 'center',
  };
  const [counter, setCounter] = useState(0);
  const { userData } = useSelector(({ login }) => login);
  const [isUploading, setIsUploading] = useState(false);
  const onDrop = (acceptedFiles, event) => {
    startUploading();
    let files = null;
    if (event?.target?.files) {
      files = Array.from(event?.target?.files);
    } else {
      files = acceptedFiles;
    }
    if (files?.length) {
      convertBlob(files); // Process the files for upload
      event.target.value = '';
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: true,
    noClick: true, // Prevents automatic file input click
  });

  const handleFileClick = () => {
    document.getElementById('fileInput').click();
  };

  const handleFolderClick = () => {
    document.getElementById('folderInput').click();
  };

  useEffect(() => {
    let interval;
    if (isUploading) {
      interval = setInterval(() => {
        setCounter((prevCounter) => {
          if (prevCounter < 100) {
            return prevCounter + 1;
          } else {
            clearInterval(interval);
            setIsUploading(false);
            return prevCounter;
          }
        });
      }, 10);
    }
    return () => clearInterval(interval);
  }, [isUploading]);

  useEffect(() => {
    if (setAllUploadsCompleted) {
      if (isUploading === false) {
        setUploadError();
      }
      setAllUploadsCompleted(!isUploading);
    }
  }, [isUploading, setAllUploadsCompleted]);

  const startUploading = () => {
    setCounter(0);
    setIsUploading(true);
  };

  function cleanPath(path) {
    if (!!path) {
      let noFirstSlash = path.startsWith('/') ? path.slice(1) : path;
      let noFileName = noFirstSlash.substring(0, noFirstSlash.lastIndexOf('/'));
      return noFileName;
    } else return '';
  }

  const convertBlob = (data) => {
    let newFiles = [];
    data.forEach((element) => {
      const fileName = element.name;
      if (fileTypesAndExtensions[element.type]) {
        let reader = new FileReader();
        reader.readAsDataURL(element);
        reader.onloadend = function () {
          let obj = {};
          obj.document_name = element.name;
          obj.document_size = element.size;
          obj.document_path = reader.result;
          obj.document_type = 'Reference Call';
          obj.added_by_user = userData.user_id;
          obj.llmprocessing = false;
          obj.file_path = !!element.path
            ? cleanPath(element.path)
            : element.webkitRelativePath
              ? cleanPath(element.webkitRelativePath)
              : '';
          newFiles.push(obj);
          if (
            newFiles.length ===
            data.filter((file) => fileTypesAndExtensions[file.type]).length
          ) {
            handleFileAddition(newFiles);
          }
        };
      }
    });
  };

  return (
    <Fragment key={id}>
      <div
        {...getRootProps({ className: 'dropzone' })}
        style={{
          alignContent: 'center',
          border: '2px dashed #6f6f6f',
          height: uploaderHeight ? uploaderHeight : '16rem',
          margin: uploaderMargin ? uploaderMargin : '11px',
          width: uploaderLength ? uploaderLength : '41rem',
          borderRadius: '6px',
          textAlign: 'center',
        }}
      >
        <input {...getInputProps()} />
        <input
          type="file"
          id="fileInput"
          multiple
          style={{ display: 'none' }}
          onChange={(e) => onDrop(e.target.files, e)}
        />
        <LuImagePlus
          size={40}
          style={{ marginBottom: '10px' }}
          className="notes-upload-icon"
        />
        <p>
          <span className="notes-upload-link" onClick={handleFileClick}>
            Upload a file
          </span>{' '}
          or drag and drop files into this box
        </p>
        <p className="notes-upload-text">MP4, MP3, M4A, TXT, DOCX, PDF</p>
      </div>
    </Fragment>
  );
};

export default NotesUploader;
